import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import type { GroupBase, OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { fieldDataTypeIcon } from '@feathr/extender/styles/fieldDataType';

import type { IFieldOptionData } from './SelectOptions.utils';
import { valueToFieldDataType } from './SelectOptions.utils';

import * as styles from './SelectOptions.css';

/**
 * react-select-modern (v5) version of FieldOption for use with the
 * UniversalSelect family; the original FieldOption wraps the legacy
 * react-select (v3) Option and only works inside the legacy selects.
 */
export function FieldOptionModern<
  T extends IFieldOptionData,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<T> = GroupBase<T>,
>(props: OptionProps<T, IsMulti, Group>): JSX.Element {
  const { data } = props;
  let icon = fieldDataTypeIcon(data.data_type ? data.data_type : valueToFieldDataType(data.value));
  if (data.id === 'create') {
    icon = faPlus;
  }
  return (
    <components.Option {...props}>
      <div className={styles.fieldOption}>
        <div className={styles.contentWrapper}>{icon && <FontAwesomeIcon icon={icon} />}</div>
        <div className={styles.fieldOptionCell}>
          <span>{data.name || data.label || data.u_key}</span>
        </div>
      </div>
    </components.Option>
  );
}
